import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FortressSunken1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FORTRESS_SUNKEN1;
}

export default FortressSunken1PoiTileEntity;
